var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.theme)?_c('v-chip',{attrs:{"dark":"","x-small":"","color":_vm.theme.color}},[_vm._v(_vm._s(_vm.theme.name))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }